import investmentDisclaimerLang from '../langs/investmentDisclaimerLang';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { Box, Divider } from '@mui/material';
import { WarningOutlined } from '@mui/icons-material';

const CInvestDisclaimer = () => {
	const { t } = useTranslation();
	return (
		<Box id="invest-disclaimer" style={{ margin: '0px 5px', position: 'relative', top: '2px', fontSize: '0.9rem' }}>
			<Divider sx={{ margin: '30px 0px' }} />
			<WarningOutlined sx={{ height: '1rem' }} />
			{t(investmentDisclaimerLang.info_tooltip.tag)}
		</Box>
	);
};

export default CInvestDisclaimer;
